import types from '../../constants';

const defaultData = {
  title: '',
  id: '',
  is_public: false,
  description: '',
  keywords: '',
};

const initialState = {
  loading: false,
  data: defaultData,
};

const ScenarioReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.SCENARIO_FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case types.SCENARIO_FETCH_END:
      return {
        ...state,
        loading: false,
        data: {...defaultData, ...action.payload},
      };
    case types.SCENARIO_UPDATE:
      return {
        ...state,
        data: {...state.data, ...action.payload}
      };
    default:
      return state;
  }
};

export default ScenarioReducers;
